import 'gsap'
import $ from 'jquery'

// import BaseComponent from '@/components/Content'
import EventBus from '@/config/event-bus'

var basePage = {
   props: ['model'],

   components: {
      // BaseComponent
   },

   computed: {
      pageComponents() {
         var attributes = this.model && this.model.attributes;

         if (!attributes) {
            return null;
         }

         return attributes.components.value;
      }
   },
   created: function() {},

   mounted(){
    console.log("init");
    this.initSmooth();
   },

   methods: {
      onScroll(e) {
         var self = this;

         console.log("EE", e.target.scrollTop);

         self.$store.dispatch('app/SET_STATE', { scrollTop: e.target.scrollTop });
         return;

         if (!ticking) {

            window.requestAnimationFrame(function() {
               self.$store.dispatch('app/SET_STATE', { scrollTop: e.target.scrollTop });
               ticking = false
            })
            ticking = true;
         }
      },
      initSmooth() {
         var self = this;

         this.$el.removeEventListener('scroll', self.onScroll);
         this.$el.addEventListener('scroll', self.onScroll)
         return
      },
      getScrollTop() {
         if (typeof pageYOffset != 'undefined') {
            //most browsers
            return pageYOffset;
         } else {
            var B = document.body; //IE 'quirks'
            var D = document.documentElement; //IE with doctype
            D = (D.clientHeight) ? D : B;
            return D.scrollTop;
         }
      },

      scrollHandler(e) {
         var top = e.srcElement.scrollTop;

         requestAnimationFrame(() => {
            EventBus.$emit('scrolling', top);
         });
      },

      mousemoveHandler(e) {
         // var top = e.srcElement.scrollTop;

         requestAnimationFrame(() => {
            EventBus.$emit('mousemove', pos);
         });
      }
   }
}


export default basePage;



// WEBPACK FOOTER //
// ./src/mixins/basePage.js